import { NumericFormatProps } from 'react-number-format';

export const emptyValue = '—';

export const formatParams: NumericFormatProps = {
  displayType: 'text',
  thousandSeparator: ',',
  decimalScale: 0,
  prefix: '$',
};
